import React from "react";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

export const NextArrowCarousel = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
      }}
      onClick={onClick}>
      <RightOutlined />
    </div>
  );
};

export const PrevArrowCarousel = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
      }}
      onClick={onClick}>
      <LeftOutlined />
    </div>
  );
};
